import { useState } from "react";
import { ISettingBtnProps } from "./SettingBtn.props";
import { removeSavedSetting } from "@store/savedMinerSettings/action";
import { useDispatch } from "react-redux";
import useApiRequests from "@services/http/useApiRequest";
import { RecordResponse } from "@services/http/responses/BaseResponse";
import { AddMinerReuest, NewMinerI } from "@services/addNewMiner";
import { makeNotifs } from "@utils/makeNotifs";
import { ALGOS_E } from "@constants/Algos";
import { addNewMinerList } from "@store/storedMiners/actions";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";

export const MAX_NUMBER = 20;

export const useSettingBtnControl = (props: ISettingBtnProps) => {
  const notifs = makeNotifs();
  const { enqueue } = useApiRequests();
  const { onLoader, onSuccess } = useGlobalNotifs();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(1);

  const onDeleteSetting = () => {
    if (!props.setting) return;
    dispatch(removeSavedSetting(props.setting.cloned_miner));
  };

  const onChangeInput = (value: string) => {
    setInputValue(Number(value));
  };

  const addMiner = async () => {
    if (inputValue < 1 || inputValue > MAX_NUMBER) return;
    onLoader(true);
    const minersToAdd = await sendReqToAddMiner();

    if (minersToAdd.length < 1) {
      onLoader(false);
      return;
    }
    dispatch(addNewMinerList(minersToAdd));
    onLoader(false);
    onSuccess(notifs.ok.success);
  };

  const sendReqToAddMiner = async (): Promise<NewMinerI[]> => {
    let error = false;
    const currSetting = props.setting;
    const settings = {
      hash: currSetting?.hash || ALGOS_E.SHA256,
      admin_text: currSetting?.notes,
      speed_drops: currSetting?.speed_drop,
      profile_id: String(currSetting?.miner_type?.id || ""),
      mining_persent: currSetting?.mining_persent,
      default_speed: currSetting?.default_speed,
      customer: currSetting?.customer.customer_id,
      location_id: currSetting?.location?.id,
    };
    const responses: NewMinerI[] = [];
    for (let j = 1; j <= inputValue; j++) {
      if (error) return responses;
      const res = await enqueue<RecordResponse<NewMinerI>>(
        new AddMinerReuest(settings)
      );
      if (!res) {
        error = true;
        continue;
      }
      responses.push(res.Record);
    }
    return responses;
  };

  return {
    inputValue,

    onDeleteSetting,
    onChangeInput,
    addMiner,
  };
};
